module.exports = __webpack_public_path__ + "static/img/second_product.03a87f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/second_product.png
// module id = Pc1Y
// module chunks = 0